var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "white",
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-block mt-2",
    on: {
      "click": _vm.openSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n              Cari Permohonan\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-block mt-2",
    on: {
      "click": _vm.openNew
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v("\n              Ajukan Permohonan\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-collapse', {
    attrs: {
      "id": "collapse"
    },
    model: {
      value: (_vm.collapse),
      callback: function($$v) {
        _vm.collapse = $$v
      },
      expression: "collapse"
    }
  }, [(_vm.modelCollapse === 'search') ? _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kodeRegistrasi),
      expression: "kodeRegistrasi"
    }],
    staticClass: "form-control",
    staticStyle: {
      "font-size": "20px",
      "padding": "10px",
      "height": "50px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Masukkan Kode Registrasi"
    },
    domProps: {
      "value": (_vm.kodeRegistrasi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.kodeRegistrasi = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-button"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getPdf
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.modelCollapse === 'new') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg btn-block",
    staticStyle: {
      "height": "100px"
    },
    on: {
      "click": _vm.routeToPenumpang
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("\n                    Barang Bawaan Penumpang")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg btn-block",
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "title": "konten belum tersedia",
      "disabled": ""
    }
  }, [_c('i', {}), _vm._v(" COMING SOON!!")])])]) : _vm._e()])], 1)])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    attrs: {
      "src": "static\\img\\icon.jpeg",
      "width": "100%",
      "alt": ""
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', [_vm._v("Menu Transit")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b522f82","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/transit/MenuTransit.vue
// module id = 400
// module chunks = 0